import fetch from './fetch'

class SettingApi {
	public getSetting(key: string) {
		return fetch({
			url: 'injury/resource/setting/get',
			params: {
				key,
			},
		})
	}

	public getSettingList(code: string) {
		return fetch({
			url: 'injury/resource/setting/getList',
			params: {
				code,
			},
		})
	}

	public getSettingLists(codeList: string[]) {
		return fetch({
			url: 'injury/resource/setting/getLists',
			method: 'POST',
			data: codeList,
		})
	}

	public getSettingListsForSnapshot(codeList: string[]) {
		return fetch({
			url: 'injury/resource/setting/snapshot/getLists',
			method: 'POST',
			data: codeList,
		})
	}
}

export default new SettingApi()
